import React, { useState } from "react";
import ssoImg1 from "./../../../../assets/images/mrcc-1.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/mrcc-2.png"; // Adjust the path as necessary
import pilotIcon from "./../../../../assets/images/user-pilot-tie.svg"; // Adjust the path as necessary
import scaleIcon from "./../../../../assets/images/scale-balanced.svg"; // Adjust the path as necessary

import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaUser, FaInstagram } from 'react-icons/fa';

function SeaWatchReponseMrccTab() {
    const cardData = [
  {
    icon: pilotIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Executes a Maritime Assistance Service (MAS)",
  },
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Manage the reception and dissemination of Maritime Security information",
  },
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "ISPS code",
  },
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Acts as the SA Navigational Communications Search and Rescue (NCSR) agency (IMO)  and the COSPAS SARSAT agency (ICAO)",
},
{
    icon: pilotIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Acts as the custodian for SA NCSR beacon registration database and",
  },
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Promote International SAR standards in terms of the South African Maritime and Aeronautical SAR Act by",
  },
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Implementing the requirements of bilateral SAR agreements and",
  },
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Providing a National and Regional maritime SAR co-ordinators training capability",
},

  
  
  

  
];



  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        SEA WATCH & RESPONSE
        <span className="text-orange-ef3e33 font-400"> MRCC </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <p className="font-18 font-900 mb-3">​
            <span className="d-block text-primary-green" style={{ fontSize: '24px', fontWeight: 800 }}>
            MRCC Role and Function</span>
            </p>
          <p className="mb-3 text-primary-color">The MRCC is fully functional and  operates 24/7 with the focus primarily of the safety of life at sea and  complies with the requirements of the Department of Transport’s (DoT)  South African Search and Rescue (SASAR) Act.</p>

          <p className="mb-3 text-primary-color">This entails interaction with the various government and non-government entities involved with maritime rescue at sea.</p>

          <p className="mb-3 text-primary-color">The MRCC performs administrative and  operational duties.  Administrative duties are concerned with  maintaining the MRCC in a continuous state of preparedness.</p>

          <p className="mb-3 text-primary-color">Operational duties are concerned with the efficient conduct of SAR operations or exercises.</p>

          <p className="font-18 font-900 mb-3">
            <span className="d-block text-primary-green" style={{ fontSize: '24px', fontWeight: 800 }}>
            The MRCC performs the following functions:</span>
            </p>

          <div className="row g-4">
            <div className="col-lg-6 col-md-12 col-sm-6" >
                <div className="gray-card-wrap">
                  <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                    <div className="icon">
                      <img src={pilotIcon} alt="" />
                    </div>
                    <div className="text-center text-primary-color">
                      
                       Monitors and evaluates Maritime Safety Information (MSI)

                    </div>

                    <div className="card-share">
                      {/* <button type="button" className="btn-share border-0" >
                        <i className="bi bi-share"></i>
                      </button> */}
                      {/* <ul >
                        <li>
                          <a href="#">
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaTwitter />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaYoutube />
                          </a>
                        </li>
                      </ul> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-6" >
                <div className="gray-card-wrap">
                  <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                    <div className="icon">
                      <img src={pilotIcon} alt="" />
                    </div>
                    <div className="text-center text-primary-color">Manages the South African Ship Reporting System (SAFREP)
</div>

                    <div className="card-share">
                      {/* <button type="button" className="btn-share border-0" >
                        <i className="bi bi-share"></i>
                      </button> */}
                      <ul >
                        <li>
                          <a href="#">
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaTwitter />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaYoutube />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
          </div>


        </div>
        {/* <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> */}
        <div className="col-12">

          <div className="row g-4">
            {cardData.map((card, index) => (
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6" key={index}>
                <div className="gray-card-wrap">
                  <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                    <div className="icon">
                      <img src={card.icon} alt="" />
                    </div>
                    <div className="text-center text-primary-color">
                      {card.cardDescription}
                    </div>

                    <div className="card-share">
                      {/* <button type="button" className="btn-share border-0" >
                        <i className="bi bi-share"></i>
                      </button> */}
                      <ul >
                        <li>
                          <a href="#">
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaTwitter />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaYoutube />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        

        <div className="col-lg">
          <p className="font-18 font-900 mb-3"><span className="d-block text-primary-green" style={{ fontSize: '24px', fontWeight: 800 }}> MRCC Role and Function</span> </p>
          <p className="mb-3 text-primary-color">As per resolutions of the IMO Florence  convention of 2000, the African continent was split into regions in  order to better manage SAR around Africa. </p>

          <p className="mb-3 text-primary-color">The countries of Nigeria,  South Africa, Morocco, Liberia and Kenya were approached to host  Regional Maritime Rescue Co-ordination Centers (RMRCC). </p>

          <p className="mb-3 text-primary-color">All have  accepted and in January 2007 MRCC Cape Town was inaugurated as the RMRCC for the Southern African region countries of Angola, Namibia,  Mozambique, Madagascar and the Comoros</p>

            <div className="row g-3">
                    <div className="col-auto">
                        <div className="focus-block bg-green-38B652 rounded-2">
                            <div className="icon"><i className="map-icon"></i></div>
                            <p>Regional SAR Maritime Region</p>
                        </div>
                    </div>
                   
                </div>

        </div>
        {/* <div className="col-lg-5">
          <img src={ssoImg2} className="img-fluid rounded-1" alt="" />
        </div> */}
      </div>
    </>
  );
}

export default SeaWatchReponseMrccTab;